import React from 'react'
import { appHistory, browserHistoryEmitter } from '@core/Utils/routing/history'
import { KAMBI_BETHISTORY_HASH_ROUTE } from '../constants'

export const useShowTransactionTabs = (): boolean => {
  const [shouldShowTransactionTabs, setShouldShowTransactionTabs] = React.useState(evaluateState)

  // Shows racing/sports transaction tabs on bethistory route
  React.useEffect(() => {
    const subscription = appHistory.listen(() => {
      setShouldShowTransactionTabs(evaluateState)
    })

    const handleUrlChange = (url: string) => {
      if (!url) return
      setShouldShowTransactionTabs(url.includes(KAMBI_BETHISTORY_HASH_ROUTE))
    }
    browserHistoryEmitter.on('pushState', handleUrlChange)
    return () => {
      subscription()
      browserHistoryEmitter.off('pushState', handleUrlChange)
    }
  }, [])

  return shouldShowTransactionTabs
}

function evaluateState() {
  const isBetHistory = appHistory.location.pathname.includes(KAMBI_BETHISTORY_HASH_ROUTE)
  return isBetHistory
}
